import React from 'react';
import { Shield, Target, Zap, Trophy } from 'lucide-react';
import { BenefitCard } from '../../components/BenefitCard';
export function AfterSchoolBenefits() {
  return <section className="py-24 bg-paper border-y border-subtle-gray" data-id="element-627">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-628">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-629">
          <h2 className="text-4xl md:text-5xl text-ink mb-6" data-id="element-630">
            Why Families Choose Storm
          </h2>
        </div>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-631">
          <BenefitCard icon={Shield} title="Confidence Building" description="Kids learn to stand tall and believe in themselves." data-id="element-632" />
          <BenefitCard icon={Target} title="Improved Focus" description="Structured drills that help with schoolwork and attention." data-id="element-633" />
          <BenefitCard icon={Zap} title="Positive Energy Outlet" description="A healthy, active way to burn off after-school energy." data-id="element-634" />
          <BenefitCard icon={Trophy} title="Goal Setting" description="Earning belts teaches the value of hard work and dedication." data-id="element-635" />
        </div>
      </div>
    </section>;
}